module.exports = __webpack_public_path__ + "img/subject.746e1917.svg";